import React from "react";
import styled from "styled-components";
import { getParagraph14RegularTypography } from "../Typography";

const Root = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const Container = styled.div`
  background-color: rgba(237, 58, 79, 0.1);
  border-radius: 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ErrorTextContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const ErrorText = styled.p`
  align-items: center;
  padding: 21px 36px 21px 25px;
  ${getParagraph14RegularTypography};
  line-height: 16px;
  color: #ff5064;
`;

const ButtonContainer = styled.div``;

const StyledButton = styled.button`
  background-color: rgba(237, 58, 79, 0.1);
  cursor: pointer;
  transition: 0.3s;
  border: 2px solid rgba(237, 58, 79);
  width: 22px;
  height: 22px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  &:hover {
    background-color: rgba(237, 58, 79, 0.3);
  }
`;

const SpanText = styled.p`
  text-align: center;
  font-size: ${({ theme }) => theme.paragraph.lg};
  color: rgba(237, 58, 79);
`;

interface IAlertMessage {
  isOpen?: boolean;
  message?: any;
  className?: any;
  style?: any;
  onClose?: () => void;
}

const AlertMessage = ({
  isOpen,
  style,
  message,
  onClose,
  className,
}: IAlertMessage) => {
  return isOpen && message ? (
    <Root style={style} className={className}>
      <Container>
        <ErrorTextContainer>
          <ErrorText>{message}</ErrorText>
        </ErrorTextContainer>
        {onClose && (
          <ButtonContainer>
            <StyledButton onClick={onClose} type="button">
              <SpanText>x</SpanText>
            </StyledButton>
          </ButtonContainer>
        )}
      </Container>
    </Root>
  ) : null;
};

export default AlertMessage;
